// extracted by mini-css-extract-plugin
export default {"email_module":"EmailForm_email_module__Anirm","header":"EmailForm_header__XWsiC"};